import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-black text-white text-center w-8/12" }, "Create a Workbean account", -1)
const _hoisted_2 = { class: "w-full align-middle mt-5 flex flex-col gap-6 bg-white shadow-base h-full rounded-t-3xl px-5 py-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "bg-light-gray-100 w-full flex justify-center items-center py-5 rounded-b-3xl" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Already on Workbean? "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-primary-violet",
      href: "/login"
    }, "Login")
  ])
], -1)

import { IonHeader, IonToolbar, IonButtons, IonBackButton } from "@ionic/vue"
  import { ref, computed } from "vue"
  import { generateSchema } from "@/utils/validate"
  import { useAuthenticationStore } from "@/store/authentication"
  import { useGtm } from "@gtm-support/vue-gtm"
  import * as jwt from "@/utils/jwt"

  import FormContainer from "@/components/template/formTemplate.vue"
  import WbTemplate from "@/components/account-creation/template.vue"
  import WbInput from "@/components/template/InputTemplate.vue"
  import WbPassword from "@/components/template/PasswordTemplate.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SignupPage',
  setup(__props) {

  const agreetoEmail = ref(false)
  const authenticationStore = useAuthenticationStore()
  const gtm = useGtm()

  const validationSchema = generateSchema([
    {
      name: "sendMail",
      rule: "email",
    },
    {
      name: "password",
      rule: "password",
    },
  ])

  const registration = computed({
    get: () => authenticationStore.registrationDetails,
    set: (val) => {
      authenticationStore.setRegistrationDetails(val)
    },
  })

  /**
   * calls for login api defined in authentication store
   */
  const submitForm = () => {
    authenticationStore.register(jwt.default.generateNBF(), gtm)
  }

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonBackButton))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(WbTemplate, null, {
      default: _withCtx(() => [
        _createVNode(FormContainer, {
          "validation-schema": _unref(validationSchema),
          class: "flex flex-col w-[25rem] items-center justify-center text-light-black",
          onValid: submitForm
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createVNode(WbInput, {
                modelValue: _unref(registration).email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(registration).email) = $event)),
                name: "sendMail",
                type: "email",
                placeholder: "Email*"
              }, null, 8, ["modelValue"]),
              _createVNode(WbPassword, {
                modelValue: _unref(registration).password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(registration).password) = $event)),
                name: "password",
                placeholder: "Password*",
                autocomplete: "new-password"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ion_button, {
                expand: "block",
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Continue")
                ]),
                _: 1
              }),
              _hoisted_3
            ]),
            _hoisted_4
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ]),
      _: 1
    })
  ], 64))
}
}

})